/*
 * Author: Blue Lobster Private Limited
 * Copyright: Blue Lobster Private Limited
 */
/**
 * Suppresses noisy console output in production builds while preserving warnings and errors.
 * @returns {void}
 */
const suppressConsoleLogs = () => {
	if (!import.meta.env.PROD) {
		return;
	}

	const noop = () => undefined;
	const methodsToSilence = ["log", "debug", "info", "trace"];

	methodsToSilence.forEach((method) => {
		if (typeof console[method] === "function") {
			console[method] = noop;
		}
	});
};

suppressConsoleLogs();
